import register from '@kpsys/angularjs-register';
import ReloaderService from './reloader.service';
import WalkerService from './walker.service';
import CurrentAuthService from './current-auth.service';
import FinishedResponseInteractionService from './finished-response-interaction.service';
import ActionRequestService from './action-request.service';
import SmsService from './sms.service';
import {UserFeedbackService} from './user-feedback.service';

export default register('portaro.shared.services')
    .service(ActionRequestService.serviceName, ActionRequestService)
    .service(WalkerService.serviceName, WalkerService)
    .service(ReloaderService.serviceName, ReloaderService)
    .service(CurrentAuthService.serviceName, CurrentAuthService)
    .service(FinishedResponseInteractionService.serviceName, FinishedResponseInteractionService)
    .service(UserFeedbackService.serviceName, UserFeedbackService)
    .service(SmsService.serviceName, SmsService)
    .name();